import { ExchangeRatesPage } from "@/modules/exchangeRate/pages";
import { AppPaths } from "@/shared/common/enums";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

export const exchangeRateRoutes: RouteObject = {
  path: "",
  element: <Layout/>,
  children: [
    {
      path: AppPaths.ExchangeRate, element: <ExchangeRatesPage/>,
      handle: {
        breadcrumb: () => ({ key: "breadcrumb.exchangeRate" })
      },
    },
  ],
};

